// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OpponentList__container-c470b3 {
  display: flex;
  overflow-x: auto;
  padding-bottom: 8px;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/CompactCallView/Shared/SpeakerVideo/Opponents/components/OpponentList/OpponentList.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  overflow-x: auto;\n  padding-bottom: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `OpponentList__container-c470b3`
};
module.exports = ___CSS_LOADER_EXPORT___;
